/* MOONZART · Crea tu look
   - La prenda principal es el producto de la página (variante del formulario original).
   - Las prendas complementarias son productos reales elegidos en el editor.
   - Al pulsar el botón original de compra (o el fijo de móvil) con un conjunto elegido,
     se añaden TODAS las variantes reales en una sola petición a /cart/add.js.
   - Sin descuentos, sin productos nuevos. */
(function () {
  if (customElements.get('mz-look-builder')) return;

  var SETS = { 'Mlic+Selene': 5690, 'Elara+Mlic+Selene': 8490, 'Flare+Selene': 5990, 'Elara+Flare+Selene': 8890, 'Mlic+Nara': 5590, 'Elara+Mlic+Nara': 8490, 'Aria+Vira': 5190, 'Aria+Elara+Vira': 8090, 'Flare+Kaia': 5490, 'Elara+Flare+Kaia': 8390, 'Elara+Flare': 5790 }; function fam(t) { var m = /(Selene|Mlic|Flare|Vira|Elara|Kaia|Aria|Nara)/.exec(String(t)); return m ? m[1] : null; } function setInfo(sel) { try { if (!sel || sel.length < 2) return null; var f = sel.map(function (it) { return fam(it.p.title); }); if (f.indexOf(null) > -1) return null; var sp = SETS[f.slice().sort().join('+')]; if (!sp) return null; var reg = 0; sel.forEach(function (it) { reg += it.v.price; }); if (!(sp < reg)) return null; return { sp: sp, reg: reg, save: reg - sp, pct: Math.round((reg - sp) / reg * 100) }; } catch (e) { return null; } } SETS = { 'Mlic+Selene': 6190, 'Elara+Mlic+Selene': 9290, 'Flare+Selene': 6590, 'Elara+Flare+Selene': 9690, 'Mlic+Nara': 6090, 'Elara+Mlic+Nara': 9290, 'Aria+Vira': 5690, 'Aria+Elara+Vira': 8890, 'Flare+Kaia': 5990, 'Elara+Flare+Kaia': 9190, 'Elara+Flare': 6390 }; var fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });
  function money(c) { return fmt.format((c || 0) / 100); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function parse(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function short(t) { return String(t).split(' – ')[0]; }

  class MzLookBuilder extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.main = parse(this.querySelector('[data-mzlk-main]'));
      if (!this.main) return;
      this.section = this.closest('.product-information') || this.closest('.shopify-section') || document;
      this.form = this.section.querySelector('form[action*="/cart/add"]');
      this.msg = this.querySelector('[data-mzlk-msg]');
      this.sum = this.querySelector('[data-mzlk-sum]');
      this.pick = {};      // productoBase -> productoElegido (color)
      this.size = {};      // producto -> varianteElegida (se conserva entre opciones)
      this.busy = false;

      this.opts = Array.prototype.map.call(this.querySelectorAll('[data-mzlk-opt]'), function (el) {
        return { el: el, key: el.dataset.key, btn: el.dataset.btn || '', comps: parse(el.querySelector('[data-mzlk-comps]')) || [] };
      });
      if (!this.opts.length) return;
      // Con una sola opción (producto sin complementos) el constructor no aporta nada: se oculta y la compra es la normal
      if (this.opts.length < 2) { this.style.display = 'none'; return; }

      var def = parseInt(this.dataset.default, 10) || 1;
      var mm = /[?&]look=(\d)/.exec(window.location.search);
      if (mm && +mm[1] >= 1 && +mm[1] <= this.opts.length) def = +mm[1];
      this.current = this.opts[Math.min(def, this.opts.length) - 1];

      var self = this;
      this.addEventListener('change', function (e) { self.onChange(e); });
      this.addEventListener('click', function (e) { self.onClick(e); });

      // Único punto de compra: se intercepta el envío del formulario original (también lo usa el botón fijo de móvil).
      // Se escucha en window (fase de captura) para actuar ANTES que el tema y que las apps de carrito.
      this._submit = function (e) { self.onSubmit(e); };
      this._click = function (e) { self.onBuyClick(e); };
      window.addEventListener('submit', this._submit, true);
      window.addEventListener('click', this._click, true);

      // Sincroniza con el selector de talla original de la ficha
      this._sync = function () { setTimeout(function () { self.render(); }, 60); };
      document.addEventListener('change', this._sync);
      this._lastId = this.mainId();
      this._timer = setInterval(function () { var id = self.mainId(), q = self.qty(); if (id !== self._lastId || q !== self._lastQ) { self._lastId = id; self._lastQ = q; self.render(); } }, 500);

      this.select(this.current.key);
    }

    disconnectedCallback() {
      window.removeEventListener('submit', this._submit, true);
      window.removeEventListener('click', this._click, true);
      document.removeEventListener('change', this._sync);
      clearInterval(this._timer);
      this.restoreButton();
      this.toggleExpress(false);
      this._ready = false;
    }

    /* ---------- Datos ---------- */
    qty() { var q = this.form && this.form.querySelector('[name="quantity"]'); return Math.max(1, parseInt(q && q.value, 10) || 1); }
    mainId() { var i = this.form && this.form.querySelector('[name="id"]'); return i ? parseInt(i.value, 10) : null; }
    mainVariant() {
      var id = this.mainId(), v = null;
      this.main.variants.forEach(function (x) { if (x.id === id) v = x; });
      return v || this.main.variants[0];
    }
    compProduct(c) {
      var id = this.pick[c.base] || c.base, p = null;
      c.products.forEach(function (x) { if (x.id === id) p = x; });
      return p || c.products[0];
    }
    compVariant(p) {
      var id = this.size[p.id], v = null;
      p.variants.forEach(function (x) { if (x.id === id) v = x; });
      if (!v) {
        // Intenta mantener la misma talla que se eligió en otro color del mismo modelo
        var want = this.sizeTitle && this.sizeTitle[p._base];
        p.variants.forEach(function (x) { if (!v && want && x.title === want && x.available) v = x; });
      }
      if (!v) p.variants.forEach(function (x) { if (!v && x.available) v = x; });
      return v || p.variants[0];
    }
    selection() {
      var self = this, mv = this.mainVariant();
      var items = [{ p: this.main, v: mv, main: true }];
      this.current.comps.forEach(function (c) {
        var p = self.compProduct(c); p._base = c.base;
        items.push({ p: p, v: self.compVariant(p), comp: c });
      });
      return items;
    }

    /* ---------- Interacción ---------- */
    select(key, anchorEl) {
      var self = this;
      var before = anchorEl ? anchorEl.getBoundingClientRect().top : null;
      this.opts.forEach(function (o) {
        var on = o.key === key;
        o.el.classList.toggle('is-active', on);
        var r = o.el.querySelector('[data-mzlk-radio]'); if (r) r.checked = on;
        var cfg = o.el.querySelector('[data-mzlk-cfg]'); if (cfg) cfg.hidden = !on;
        if (on) self.current = o;
      });
      this.hideMsg();
      this.render();
      if (before != null) { var d = anchorEl.getBoundingClientRect().top - before; if (Math.abs(d) > 1) this.scroller().scrollBy(0, d); }
    }
    scroller() {
      // El tema puede desplazar la página dentro de un contenedor (p. ej. .page-wrapper) en lugar de la ventana
      var e = this.parentElement;
      while (e && e !== document.body) { var oy = getComputedStyle(e).overflowY; if ((oy === 'auto' || oy === 'scroll') && e.scrollHeight > e.clientHeight) return e; e = e.parentElement; }
      return window;
    }
    onClick(e) {
      var sw = e.target.closest('[data-mzlk-color]');
      if (sw) {
        e.preventDefault();
        this.pick[parseInt(sw.dataset.base, 10)] = parseInt(sw.dataset.mzlkColor, 10);
        this.render();
      }
    }
    onChange(e) {
      var t = e.target;
      if (t.matches('[data-mzlk-radio]')) { this.select(t.value, t.closest('[data-mzlk-opt]')); return; }
      if (t.matches('[data-mzlk-size]')) {
        var pid = parseInt(t.dataset.product, 10), vid = parseInt(t.value, 10), base = parseInt(t.dataset.base, 10);
        this.size[pid] = vid;
        this.sizeTitle = this.sizeTitle || {};
        var opt = t.options[t.selectedIndex]; if (opt) this.sizeTitle[base] = opt.dataset.title;
        this.hideMsg(); this.render();
        return;
      }
      if (t.matches('[data-mzlk-main-size]')) {
        // Cambia la talla en el selector ORIGINAL de la ficha (fuente única de verdad)
        var orig = this.section.querySelector('[data-cs-size-select]');
        if (orig) { orig.value = t.value; orig.dispatchEvent(new Event('change', { bubbles: true })); }
        this.hideMsg();
      }
    }

    /* ---------- Pintado ---------- */
    render() {
      var self = this;
      var keep = this.current;
      this.opts.forEach(function (o) {
        self.current = o;
        var total = 0, sel0 = self.selection(); sel0.forEach(function (it) { total += it.v.price; }); var info0 = setInfo(sel0);
        var el = o.el.querySelector('[data-mzlk-total]'); if (el) { if (info0) { el.style.textAlign = 'right'; el.innerHTML = '<span style="display:block;font-size:11px;font-weight:400;opacity:.6">Por separado <s>' + money(info0.reg) + '</s></span><span style="display:block">' + money(info0.sp) + '</span><span style="display:block;font-size:11px;font-weight:600;letter-spacing:.04em;color:#0a7a3d">AHORRAS ' + money(info0.save) + ' (' + info0.pct + ' %)</span>'; } else { el.textContent = money(total); } }
        self.paintMedia(o);
      });
      this.current = keep;
      this.paintCfg(this.current);
      this.paintSummary();
      this.paintSticky();
      this.updateButton();
    }
    paintMedia(o) {
      var box = o.el.querySelector('[data-mzlk-media]');
      if (!box) return;
      var html = '', sel = this.selection();
      sel.forEach(function (it) {
        var img = it.v.image || it.p.image;
        if (img) html += '<span class="mzlk-thumb' + (it.comp && it.comp.crop ? ' mzlk-thumb--top' : '') + '"><img src="' + esc(img) + '" alt="' + esc(it.p.title) + '" loading="lazy" width="120" height="160"></span>';
      });
      if (box._html !== html) { box.innerHTML = html; box._html = html; }
    }
    sizeSelect(p, v, base, isMain) {
      var h = '<select class="mzlk-sel" ' + (isMain ? 'data-mzlk-main-size' : 'data-mzlk-size data-product="' + p.id + '" data-base="' + base + '"') + ' aria-label="Talla de ' + esc(p.title) + '">';
      p.variants.forEach(function (x) {
        var val = isMain ? x.option1 : x.id;
        h += '<option value="' + esc(val) + '" data-title="' + esc(x.title) + '"' + (x.id === v.id ? ' selected' : '') + (x.available ? '' : ' disabled') + '>' + esc(x.title) + (x.available ? '' : ' · Agotada') + '</option>';
      });
      return h + '</select>';
    }
    paintCfg(o) {
      var cfg = o.el.querySelector('[data-mzlk-cfg]');
      if (!cfg) return;
      var self = this, html = '';
      var hasOrig = !!this.section.querySelector('[data-cs-size-select]') && this.main.options.length === 1;
      this.selection().forEach(function (it) {
        var img = it.v.image || it.p.image;
        html += '<div class="mzlk-row' + (it.v.available ? '' : ' is-out') + '">';
        html += '<span class="mzlk-row__img' + (it.comp && it.comp.crop ? ' mzlk-row__img--top' : '') + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="120" height="160">' : '') + '</span>';
        html += '<span class="mzlk-row__info"><span class="mzlk-row__t">' + esc(it.p.title) + '</span>';
        if (it.comp && it.comp.note) html += '<span class="mzlk-row__note">' + esc(it.comp.note) + '</span>';
        if (it.comp && it.comp.colors && it.comp.products.length > 1) {
          if (it.p.color) html += '<span class="mzlk-row__c">Color: ' + esc(it.p.color) + '</span>';
          html += '<span class="mzlk-sw" role="group" aria-label="Color">';
          it.comp.products.forEach(function (cp) {
            var on = cp.id === it.p.id;
            html += '<button type="button" class="mzlk-sw__b' + (on ? ' is-on' : '') + '" data-mzlk-color="' + cp.id + '" data-base="' + it.comp.base + '" title="' + esc(cp.color || cp.title) + '" aria-label="' + esc(cp.color || cp.title) + '" aria-pressed="' + on + '" style="--c:' + esc(cp.swatch || '#ccc') + '"></button>';
          });
          html += '</span>';
        }
        html += '<span class="mzlk-row__ctl">';
        if (it.main) {
          html += hasOrig ? self.sizeSelect(it.p, it.v, 0, true) : '<span class="mzlk-row__v">' + esc(it.v.title) + '</span>';
        } else {
          html += self.sizeSelect(it.p, it.v, it.comp.base, false);
        }
        html += '<span class="mzlk-row__p">' + money(it.v.price) + '</span></span>';
        if (!it.v.available) html += '<span class="mzlk-row__out">Agotada en esta talla</span>';
        html += '</span></div>';
      });
      var ae = document.activeElement, fx = ae && cfg.contains(ae) ? (ae.getAttribute('data-product') || (ae.hasAttribute('data-mzlk-main-size') ? 'main' : null)) : null;
      cfg.innerHTML = html;
      if (fx) { var nf = fx === 'main' ? cfg.querySelector('[data-mzlk-main-size]') : cfg.querySelector('[data-product="' + fx + '"]'); if (nf) nf.focus({ preventScroll: true }); }
    }
    paintSummary() {
      if (!this.sum) return;
      var sel = this.selection(), total = 0, out = false;
      sel.forEach(function (it) { total += it.v.price; if (!it.v.available) out = true; });
      var info = setInfo(sel), n = sel.length, q = this.qty(), isSet = n > 1;
      var qtxt = 'Cantidad: ' + q + (isSet ? (q === 1 ? ' conjunto' : ' conjuntos') + ' (' + (n * q) + ' prendas en total)' : (q === 1 ? ' unidad' : ' unidades'));
      this.sum.innerHTML = '<span class="mzlk-sum__l">Tu selección · ' + n + (n === 1 ? ' prenda' : ' prendas') + (isSet ? ' por conjunto' : '') + '</span>' +
        '<span class="mzlk-sum__items">' + sel.map(function (it) { return '<span class="mzlk-sum__it">' + esc(short(it.p.title)) + (it.p.color ? ' · ' + esc(it.p.color) : '') + ' — talla ' + esc(it.v.title) + (it.v.available ? '' : ' (agotada)') + '</span>'; }).join('') + '</span>' +
        '<span class="mzlk-sum__t">Total <strong>' + money((info ? info.sp : total) * q) + '</strong></span>' + (info ? '<span class="mzlk-sum__q" style="color:#0a7a3d;font-weight:600">Por separado ' + money(total * q) + ' · AHORRAS ' + money(info.save * q) + ' (' + info.pct + ' %)</span>' : '') + '<span class="mzlk-sum__q">' + qtxt + '</span>';
      this.sum.classList.toggle('is-out', out);
    }

    /* Barra fija del tema: con un conjunto muestra el look elegido, sus tallas y el total real */
    paintSticky() {
      var st = document.querySelector('sticky-add-to-cart'); if (!st) return;
      var t = st.querySelector('.sticky-add-to-cart__title'), v = st.querySelector('.sticky-add-to-cart__variant'), p = st.querySelector('.sticky-add-to-cart__price');
      if (!t) return;
      var sel = this.selection(), total = 0; sel.forEach(function (it) { total += it.v.price; });
      if (sel.length > 1) {
        var ttl = this.current.el.querySelector('.mzlk-opt__title');
        if (t._mzO == null) t._mzO = t.textContent;
        t.textContent = ttl ? ttl.textContent : t._mzO;
        if (v) { if (v._mzO == null) v._mzO = v.textContent; v.textContent = sel.length + ' prendas · ' + sel.map(function (it) { return it.v.title; }).join(' + ') + ' · ' + money((setInfo(sel) ? setInfo(sel).sp : total) * this.qty()); }
        if (p) p.setAttribute('data-mzlk-hide', '');
      } else {
        if (t._mzO != null) { t.textContent = t._mzO; t._mzO = null; }
        if (v && v._mzO != null) { v.textContent = v._mzO; v._mzO = null; }
        if (p) p.removeAttribute('data-mzlk-hide');
      }
    }

    /* ---------- Botón original ---------- */
    buttons() { return Array.prototype.slice.call(document.querySelectorAll('.product-information [ref="addToCartButton"], sticky-add-to-cart [ref="addToCartButton"]')); }
    textNode(btn) {
      var w = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) { if (n.nodeValue.trim().length > 3 && !n.parentElement.closest('svg')) return n; }
      return null;
    }
    updateButton() {
      var self = this, label = this.current.comps.length ? this.current.btn : '';
      this.buttons().forEach(function (b) {
        var t = self.textNode(b); if (!t) return;
        if (b._mzOrig == null) b._mzOrig = t.nodeValue;
        t.nodeValue = label ? ' ' + label + ' ' : b._mzOrig;
      });
      this.toggleExpress(!!label || this.current.comps.length > 0);
    }
    toggleExpress(hide) {
      var nodes = this.section.querySelectorAll('shopify-accelerated-checkout, .shopify-payment-button, [class*="accelerated-checkout"]');
      Array.prototype.forEach.call(nodes, function (n) { if (hide) n.setAttribute('data-mzlk-hide', ''); else n.removeAttribute('data-mzlk-hide'); });
    }
    restoreButton() {
      var self = this;
      this.buttons().forEach(function (b) { var t = self.textNode(b); if (t && b._mzOrig != null) t.nodeValue = b._mzOrig; });
    }

    /* ---------- Compra ---------- */
    onBuyClick(e) {
      var b = e.target.closest && e.target.closest('button[type="submit"], [ref="addToCartButton"]');
      if (!b || !this.form || (b.form !== this.form && !this.form.contains(b))) return;
      this.onSubmit({ target: this.form, preventDefault: function () { e.preventDefault(); }, stopImmediatePropagation: function () { e.stopImmediatePropagation(); } });
    }
    onSubmit(e) {
      var f = e.target;
      if (f !== this.form || !this.current || !this.current.comps.length) return; // «Solo top»: el formulario original actúa normal
      e.preventDefault();
      e.stopImmediatePropagation();
      if (this.busy) return;
      var sel = this.selection();
      var bad = sel.filter(function (it) { return !it.v || !it.v.available; });
      if (bad.length) { this.showMsg(this.dataset.msgOut); this.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      var q = this.form && this.form.querySelector('[name="quantity"]'); var qty = Math.max(1, parseInt(q && q.value, 10) || 1);
      var items = sel.map(function (it) { return { id: it.v.id, quantity: qty }; });
      this.add(items);
    }
    add(items) {
      var self = this, root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      this.busy = true; this.classList.add('is-busy'); this.hideMsg();
      this.buttons().forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { self.showMsg((res.j && (res.j.description || res.j.message)) || self.dataset.msgErr); return; }
          var opened = false;
          try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
          try { if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); opened = true; } } catch (e) {}
          if (!opened) window.location.href = root + 'cart';
        })
        .catch(function () { self.showMsg(self.dataset.msgErr); })
        .then(function () {
          self.busy = false; self.classList.remove('is-busy');
          self.buttons().forEach(function (b) { b.removeAttribute('aria-busy'); });
        });
    }
    showMsg(t) { if (this.msg) { this.msg.textContent = t; this.msg.hidden = false; } }
    hideMsg() { if (this.msg) this.msg.hidden = true; }
  }

  customElements.define('mz-look-builder', MzLookBuilder);
})();
